import { Link } from "react-router-dom";

const towns = [
  {
    name: "Picayune",
    url: "https://www.google.com/maps/place/Picayune,+MS",
  },
  {
    name: "Poplarville",
    url: "https://www.google.com/maps/place/Poplarville,+MS",
  },
  {
    name: "Carriere",
    url: "https://www.google.com/maps/place/Carriere,+MS",
  },
  {
    name: "Nicholson",
    url: "https://www.google.com/maps/place/Nicholson,+MS",
  },
  {
    name: "Pearl River County",
    url: "https://www.google.com/maps/place/Pearl+River+County,+MS",
  },
  {
    name: "Hancock County",
    url: "https://www.google.com/maps/place/Hancock+County,+MS",
  },
  {
    name: "Harrison County",
    url: "https://www.google.com/maps/place/Harrison+County,+MS",
  },
  {
    name: "Slidell",
    url: "https://www.google.com/maps/place/Slidell,+LA",
  },
  {
    name: "Bogalusa",
    url: "https://www.google.com/maps/place/Bogalusa,+LA",
  },
  {
    name: "Covington",
    url: "https://www.google.com/maps/place/Covington,+LA",
  },
  {
    name: "Mandeville",
    url: "https://www.google.com/maps/place/Mandeville,+LA",
  },
  {
    name: "Gulfport",
    url: "https://www.google.com/maps/place/Gulfport,+MS",
  },
  {
    name: "Biloxi",
    url: "https://www.google.com/maps/place/Biloxi,+MS",
  },
];

export default function WelcomeSection() {
  return (
    <section className="bg-white py-14 md:py-16">
      <div className="max-w-[1400px] mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-start">
          {/* Text content */}
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-5">
              Welcome to ATLAS PRO SERVICES LLC
            </h1>
            <p className="text-gray-600 text-sm leading-relaxed">
              ATLAS PRO SERVICES LLC is located in{" "}
              <a
                href="https://www.google.com/maps/place/Picayune,+MS"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1e2a5e] underline hover:text-[#2a3a7a]"
              >
                Picayune, Mississippi
              </a>
              . We serve the{" "}
              <a
                href="https://www.google.com/maps/place/Pearl+River+County,+MS"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#1e2a5e] underline hover:text-[#2a3a7a]"
              >
                Gulf Coast region
              </a>{" "}
              including{" "}
              {towns.map((town, index) => (
                <span key={town.name}>
                  <a
                    href={town.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#1e2a5e] underline hover:text-[#2a3a7a]"
                  >
                    {town.name}
                  </a>
                  {index < towns.length - 2
                    ? ", "
                    : index === towns.length - 2
                      ? " & "
                      : "."}
                </span>
              ))}
            </p>
          </div>

          {/* Image */}
          <div>
            <img
                          src="/images/IMG_1310.jpg"
              alt="ATLAS PRO SERVICES finished pool installation"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}